<template>
	<div class="xs-12">
		<!-- Language selector -->
		<div class="xs-12 bg5">
			<div class="xs-4 mb4" v-if="$store.state.settings.allowedLocales">
				<div class="pr2 xs-12 fs3 lh125 fw7 pb2">{{ $t("language") }}</div>
				<core-select-locale
					class="xs-12"
					size="xsmall"
					:value="selectedLocale"
					@input="$emit('selectedLocale', $event)"
				/>
			</div>
		</div>
		<!-- Html -->
		<core-rich-text-editor :content="content" @input="updateInput" />

		<div class="xs-12 p2 fs3 bg7 c6 mt2">{{ $t("insert_variables_by") }}</div>
	</div>
</template>

<script>
import debounce from "lodash.debounce"
import CoreSelectLocale from "@/modules/core/components/CoreSelectLocale"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		CoreRichTextEditor: () =>
			import("@/modules/core/components/CoreRichTextEditor/"),
		CoreSelectLocale
	},

	props: {
		id: String,
		content: String,
		selectedLocale: String
	},

	methods: {
		updateInput: debounce(async function(value) {
			const query = gql`
				mutation upsertL10n($l10n: upsertL10nInput) {
					upsertL10n(l10n: $l10n) {
						status
						errors
					}
				}
			`
			const variables = {
				l10n: {
					locale: this.selectedLocale,
					key: `templates-${this.id}-html`,
					value
				}
			}
			this.$emit("isLoading", true)
			const res = await api({ query, variables })
			this.$emit("isLoading", false)

			/* We don't fetch on successful updates to avoid the cursor to jump in the beginning */

			if (res?.data?.upsertL10n?.errors) {
				this.$store.dispatch("showError", res.data.upsertL10n.errors)
				this.$emit("fetch")
			}
		}, 500)
	},

	watch: {
		selectedLocale: {
			handler(o, n) {
				if (o && n) {
					this.$emit("fetch")
				}
			}
		}
	}
}
</script>

<style></style>
